// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SSOSuccessVideoModalComponent } from 'src/app/modals/sso-success-video-modal/sso-success-video-modal.component';
//env has to be dev in order for videos to actually work
import { environment } from 'src/environments/environment';
import { from, pipe, takeWhile } from 'rxjs';
import { DealershipService } from '../../services/dealership.service';
import { SettingsService } from '@services/settings.service';
import { ErrorModalComponent } from 'src/app/modals/error-modal/error-modal.component';
import { PermissionsService } from '@services/permissions.service';
import { UserPermissionIds } from '../../interfaces/user.interfaces';
import { ContentService } from '@services/content.service';
import { Dealer } from '@interfaces/dealer.interfaces';

const rootUrl = '/dashboard';
export const route = 'help/gettingstarted';
export const fullRoute = `${rootUrl}/${route}`;

@Component({
    selector: 'admin-getting-started',
    templateUrl: './admin-getting-started.component.html',
    styleUrls: ['./admin-getting-started.component.scss'],
})
export class AdminGettingStartedComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    dealerCode: string;
    dealerName: string;
    isBanner = false;
    env: string = environment.env;
    envVideoUrl: string = environment.videoSrcUrl;
    helpContent: any[];
    dealer: Dealer;
    public supportPhone: string = '';
    public supportEmail: string = '';

    constructor(
        private readonly dialog: MatDialog,
        private readonly router: Router,
        readonly route: ActivatedRoute,
        private readonly dealershipService: DealershipService,
        private readonly settingsService: SettingsService,
        private readonly permissionService: PermissionsService,
        private readonly contentService: ContentService
    ) {
        //Doesn't look like this activatedRouteParams work or is actually needed?
        route.params.subscribe((activatedRouteParams) => {
            this.dealerCode = decodeURIComponent(activatedRouteParams?.dealerCode);
            this.dealerName = decodeURIComponent(activatedRouteParams?.dealerName);
        });
    }

    ngOnInit() {
        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe((dealer) => {
            this.dealer = dealer;
            from(this.settingsService.getOemSettings())
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((settings) => {
                    this.supportPhone = settings.supportPhone;
                    this.supportEmail = settings.supportEmail;
                });
        });
    }

    public async goToLogin(): Promise<void> {
        await this.router.navigate(['login']);
    }

    openVideo(title: string, source: string): void {
        this.dialog.open(SSOSuccessVideoModalComponent, {
            width: '700px',
            closeOnNavigation: false,
            data: {
                videoTitle: title,
                videoSource: this.envVideoUrl + source,
            },
        });
    }

    goToNewTab(urlLocation) {
        const url = this.router.createUrlTree(['dashboard', urlLocation]).toString();
        if (urlLocation === 'dealerManagement') {
            if (this.permissionService.hasPermission(UserPermissionIds.DealerInfoManagement)) {
                window.open(url, '_blank');
            } else {
                this.contentService
                    .permissionsMissingError(this.dealer.oemCode)
                    .pipe(takeWhile(() => this.isComponentAlive))
                    .subscribe((message) => {
                        this.dialog.open(ErrorModalComponent, {
                            width: '700px',
                            data: {
                                title: 'Access Restricted',
                                message,
                            },
                        });
                    });
            }
        } else if (urlLocation === 'userManagement') {
            if (this.permissionService.hasPermission(UserPermissionIds.UserAdmin)) {
                window.open(url, '_blank');
            } else {
                this.contentService
                    .permissionsMissingError(this.dealer.oemCode)
                    .pipe(takeWhile(() => this.isComponentAlive))
                    .subscribe((message) => {
                        this.dialog.open(ErrorModalComponent, {
                            width: '700px',
                            data: {
                                title: 'Access Restricted',
                                message,
                            },
                        });
                    });
            }
        } else {
            window.open(url, '_blank');
        }
    }

    closeBanner() {
        this.isBanner = false;
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
